<template>
  <div class="w-100 text-primary">
    <div class="gs-tips" v-if="$store.state.globalSearchAssetTypes.filter(t => assetTypes[t]).length">
      <div class="gs-tip" v-for="t in $store.state.globalSearchAssetTypes" v-if="assetTypes[t]" :key="t">{{assetTypes[t]}}</div>
    </div>
    <div class="gs-tips" v-if="published[$store.state.globalSearchPublished.toString()]">
      <div class="gs-tip">
        {{published[$store.state.globalSearchPublished.toString()]}}
      </div>
    </div>
  </div>
</template>

<script>

export default {

  props: {},
  data() {
    return {
      assetTypes: {
        "3D": "3D Assets: Highly detailed and rich 3D assets with animations, labels and tagged concepts.",
        "image": "Images: High resolution images with labels depicting a concept. These have been obtained from licenses sources or created in house.",
        "vr_image": "VR Images: High resolution images with labels depicting a concept.",
        "animation": "2D animations: Animated assets depicting concepts.",
        "simulations": "Simulations: Embibe’s in house virtual labs. These run on a Unity engine.",
        "coobos": "Lessons: Prebuilt interactive lessons powered with 3D assets, videos, questions, and activities aligned with the curriculum. These are available with and without voice and are used in our Teach platform in India. The same can be adapted to any pedagogy.",
        "videos": "Videos: Highly engaging animated learning videos for concepts of science, math, and social science with realistic, lifelike visuals."
      },
      published: {
        "true": "Published assets: Assets that are meta-tagged, reviewed, and validated by academic experts and artists.",
        "false": "Unpublished assets: Assets that are yet to be reviewed by either academic experts or artists but can be turned around very fast.",
        "any": "Published assets: Assets that are meta-tagged, reviewed, and validated by academic experts and artists.",
      }
    }
  },
  mounted() {},
  methods: {
  }
}
</script>

<style scoped>
  .gs-tips {
    margin: 5px 10px 10px 10px;
    padding: 0 0 10px 0;
    width: calc(100% - 30px);
    border-bottom: 1px solid currentColor;
  }
  .gs-tips:last-child {
    border-bottom: none;
  }
  .gs-tip {
    width: 100%;
    white-space: normal;
    padding: 5px;
  }
</style>
